import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { CHILDREN_PROPTYPES } from 'base/constants/propTypes';

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    },
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    }
  }
}));

const Flex = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
};

Flex.propTypes = { children: CHILDREN_PROPTYPES.isRequired };

export default Flex;
